// ============================================
// HOOKS/USEFAMILIAS.JS — las 13 familias de trabajo, pedidas UNA vez por carga de pagina
// ============================================
// RUBROS (2026-10-16). La lista vive en el servidor (src/services/familiasTrabajo.js) y se pide a
// GET /api/catalogo/productos/familias. Son 13 y no cambian, asi que se guardan en memoria de modulo
// y todas las pantallas (selector de familia, filtro por rubro, agrupacion de cotizaciones) comparten
// la misma lista y las mismas etiquetas. Si no hay red, se devuelve [] y la pantalla sigue viva.
import { useEffect, useState } from 'react';
import { API_BASE } from '../config/api';
import { authHeaders } from '../utils/storage';

let _cache = null;
let _enVuelo = null;

export function cargarFamilias() {
  if (_cache) return Promise.resolve(_cache);
  if (!_enVuelo) {
    // OJO CON LA RUTA: el router de productos se monta en `/api/catalogo/productos`, asi que el
    // endpoint completo es `/api/catalogo/productos/familias` (lo cazo la prueba en el emulador).
    _enVuelo = fetch(`${API_BASE}/api/catalogo/productos/familias`, { headers: authHeaders() })
      .then(x => (x.ok ? x.json() : null))
      .then(r => { if (r && r.ok && Array.isArray(r.familias)) _cache = r.familias; return _cache || []; })
      .catch(() => [])
      .finally(() => { _enVuelo = null; });
  }
  return _enVuelo;
}

export default function useFamilias() {
  const [familias, setFamilias] = useState(_cache || []);
  useEffect(() => {
    if (_cache) return undefined;
    let vivo = true;
    cargarFamilias().then(f => { if (vivo) setFamilias(f); });
    return () => { vivo = false; };
  }, []);
  return familias;
}

// Etiqueta legible de un id de familia ('cctv' -> 'CCTV y videovigilancia'). Si la lista no ha
// llegado, devuelve el id para no dejar un hueco en pantalla.
export function etiquetaFamilia(id, familias) {
  const f = (familias || []).find(x => x.id === id);
  return f ? f.etiqueta : (id || '');
}
